<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-30 16:38:05
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-17 17:19:39
 * @FilePath: \standard-v5\src\views\OpinionPublish\detail\Project.vue
 * @Description: 意向发布-填写项目信息
-->
<template>
  <div class="project">
    <div class="top-btn" v-if="permission['JZYTXXMXX'].isShow">
      <div class="btn" @click="showSelectUnit">
        <img src="@/assets/img/opinionPublish/project_icon.png">
        <span>{{ permission['JZYTXXMXX'].label }}</span>
      </div>
    </div>
    <div class="main">
      <div class="project-info">
        <!-- <div class="box-title">{{ navTitle }}</div> -->
        <div v-for="(item, index) in listData" :key="index">
          <div class="xzq" v-if="item.isShow && item.key=='XZQ'">
            <appoint-input
              style="flex: 1;"
              :title="item.label"
              :placeholder="item.placeholder"
              :isCheck="item.isCheck"
              :dictKey="item.dictKey"
              v-model="componentData[item.key]"
              :type="item.type"
              ref="XZQ"
            />
            <appoint-input
              class="xxdz"
              title="详细地址"
              :placeholder="permission['GCXXDD'].placeholder"
              :dictKey="permission['GCXXDD'].dictKey"
              v-model="componentData['GCXXDD']"
              :type="permission['GCXXDD'].type"
            />
          </div>
          <appoint-input
            v-else-if="item.isShow &&item.key!='GCXXDD'&& (item.type ? item.type != 'button' : false)"
            :title="item.label"
            :placeholder="item.placeholder"
            :isCheck="item.isCheck"
            :dictKey="item.dictKey"
            v-model="componentData[item.key]"
            :type="item.type"
            :titleButton="item.key == 'GCBH' ? permission.DQXMXX : {}"
            @titleClick="titleClick"
          />
        </div>
      </div>
    </div>
    <appoint-unit ref="AppointUnit"></appoint-unit>
  </div>
</template>

<script>
// import api from '@/utils/api/opinionPublish'
import appointApi from '@/utils/api/appoint'
import AppointInput from '@/components/ProjectAppoint/appoint-input.vue'
import AppointUnit from '@/components/ProjectAppoint/appoint-unit.vue'
// import moduleMixins from '@/mixins/moduleMixins'
import { mapGetters } from 'vuex'

const DQXMXX = 'DQXMXX'
const GCBH = 'GCBH'
const XZQ = 'XZQ'
export default {
  components: { AppointInput, AppointUnit },
  // mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      permission: {},
      listData: [],
      componentData: {}
    }
  },
  watch: {},
  computed: {
    ...mapGetters('opinion', ['getOpinionData']),
    // navTitle() {
    //   return this.getOpinionData(1).componentDesc || '填写项目信息'
    // },
    isCheck() {
      let isCheck = true
      if (Object.keys(this.componentData).length == 0) {
        return false
      }
      // 必填项
      for (let i in this.listData) {
        let key = this.listData[i].key
        // console.log(key, this.listData[key].label, this.listData[key].key)
        if (this.listData[i].isShow === true && this.listData[i].isCheck === true && !this.componentData[key]) {
          console.log(key, this.listData[i])
          isCheck = false
        }
      }
      return isCheck
    },
  },
  methods: {
    showSelectUnit() {
      this.$refs['AppointUnit'].showUnit = true
    },
    titleClick(val) {
      if (val.buttonKey == DQXMXX) {
        // 线上真实数据 开发调试时使用
        // const data = {
        //   "JSDWSHXYDM": "12421200562733249E",
        //   "YDMJ": "30523",
        //   "XMGM": "万年路交叉口至龙泉路交叉口，全长1300米，宽22米的道路、人行道、绿化带、给排水、强弱电及路灯等",
        //   "GCBH": "2017-421202-78-01-116069",
        //   "GCMC": "教育路市政道路建设工程",
        //   "LXDH": "17720359290",
        //   "WTDW": "咸宁市政府投资项目建设管理局",
        //   "XMXXDZ": "万年路至龙泉路",
        //   "XMBSM": "20f5aeae394c8ff2a4c6a2553a792602",
        //   "XZQ": "天河区",
        //   "JZMJ": "30523"
        // }
        // for (const key in data) {
        //   console.log(key)
        //   if(key == 'XMXXDZ') {
        //     this.$set(this.componentData, 'GCXXDD', data['XMXXDZ'])
        //   } else {
        //     this.$set(this.componentData, key, data[key])
        //   }
        // }
        // let options = this.$refs['XZQ'][0].options
        // options.forEach(item => {
        //   console.log(item.showValue, data['XZQ'])
        //   if(item.showValue == data['XZQ']) this.componentData['XZQCode'] = item.code
        // })
        // return
        let params = {
          code: this.componentData[GCBH],
          xzq: this.componentData[XZQ]
        }
        appointApi
          .getGGProjectInfo(params)
          .then(res => {
            let list = res.data.rowsList
            if (list.length > 0) {
              const data = list[0]
              console.log('data', data)
              for (const key in data) {
                if(key == 'XMXXDZ') {
                  this.$set(this.componentData, 'GCXXDD', data['XMXXDZ'])
                } else {
                  this.$set(this.componentData, key, data[key])
                }
              }
              let options = this.$refs['XZQ'][0].options
              options.forEach(item => {
                console.log(item.showValue, data['XZQ'])
                if(item.showValue == data['XZQ']) this.componentData['XZQCode'] = item.code
              })
            } else {
              this.$toast('无此项目信息')
            }
            console.log(list)
          })
          .catch(err => {
            console.log(err)
            this.$toast('无此项目信息')
          })
      }
    },
    dealData() {
      this.permission = this.getOpinionData(1).permission
      let list = []
      if(this.permission.commonFieldSort) {
        this.permission.commonFieldSort.forEach(key => {
          list.push(this.permission[key])
        })
      } else {
        list = this.permission
      }
      // 根据项目编号获取项目信息 按钮
      if (Object.keys(this.permission[DQXMXX]).length > 0) {
        let index = list.findIndex(item => item.key==GCBH)
        list[index].titleButton = this.permission[DQXMXX]
      }
      let completedData = this.getOpinionData(1).data
      // let list = this.$parent.allData[1].permission
      // let completedData = this.$parent.allData[1].data
      for(let key in this.permission) {
        let element = this.permission[key]
        // 不显示意向有效期
        if(element.key=='YXYXQ') {
          element.isShow = false
          element.isCheck = false
        }
        // 进入时生成字段，返回上一步时赋值所填内容
        if(element.key && element.isShow) {
          this.$set(this.componentData, element.key, completedData[element.key])
        }
      }
      this.listData = list
      console.log('component:', list)
      
      if(!this.componentData.LXR) {
        // 获取用户信息注入
        let userInfo = this.$store.state.userInfo
        this.componentData.LXR = userInfo.LXR
        this.componentData.LXDH = userInfo.mobilePhone
        this.componentData.DZYX = userInfo.mailBox
        this.componentData.WTDW = userInfo.DWMC
      }
    },
  },
  created() {
    this.dealData()
    // console.log('----:', this.$parent.allData[1].permission, this.componentData)
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.project {
  .top-btn {
    background-color: #fff;
    padding: 15px;
    .btn {
      width: 100%;
      height: 6vh;
      color: #fff;
      background-image: url('../../../assets/img/opinionPublish/project_bg.png');
      background-size: cover;
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 26px;
        margin: 0 10px;
      }
      span {
        color: #1D84FF;
      }
    }
  }
  .main {
    margin-top: 20px;
    .project-info {
      height: 100%;
      background: #ffffff;
      padding: 10px 15px 80px;
      box-sizing: border-box;
      .box-title {
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        padding: 10px 0px;
      }
      .tips {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        padding-top: 10px;
        span {
          color: #1d84ff;
          text-decoration: underline;
        }
      }
      .project-service {
        padding: 10px 10px;
        border: 1px solid #dddddd;
        .service-title {
          font-size: 14px;
          padding: 10px 0px;
          font-weight: bold;
          color: #333333;
        }
        .checkbox {
          padding: 10px 0px;
          font-size: 14px;
          color: #333333;
        }
      }
      .xzq {
        display: flex;
        .xxdz {
          flex: 2;
          margin-left: 10px;
          ::v-deep .appoint-title {
            opacity: 0;
          }
        }
      }
    }
  }
  .picker {
    ::v-deep .van-picker__toolbar {
      border-bottom: 1px solid #dddddd;
    }
    ::v-depp .van-picker__confirm {
      color: #1d84ff;
    }
    ::v-deep .van-picker-column__item {
      color: #999999;
    }
    ::v-deep .van-picker__cancel {
      color: #999999;
    }
    ::v-deep .van-picker__mask {
      background-image: none;
    }
    ::v-deep .van-picker-column__item--selected {
      color: #1d84ff;
    }
  }
}
</style>
